var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { PropTypes, Component } from 'react';

let spinnerTimerId = null;

export const composeSpinner = WrappedComponent => {
    class EnhancedComponent extends WrappedComponent {

        constructor(props) {
            super(props);

            this.startTime = () => {
                clearTimeout(spinnerTimerId);
                spinnerTimerId = setTimeout(() => {
                    this.setState({
                        isLoading: true
                    });
                }, this.LOADING_PERIOD);
            };

            this.clearSpinner = () => {
                clearTimeout(spinnerTimerId);
                if (this.state.isLoading) {
                    this.setState({
                        isLoading: false
                    });
                }
            };

            this.LOADING_PERIOD = 1000;
            this.state = _extends({}, this.state, {
                isLoading: false,
                startLoading: null
            });
        }

        componentWillUnmount() {
            clearTimeout(spinnerTimerId);
            this.clearSpinner();
            super.componentWillUnmount();
        }

        render() {
            return null;
        }
    }

    return EnhancedComponent;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/hoc/composeSpinner.js